import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Veendu, et kõik sõnad oleksid kirjavigadeta.

  <span style="color:#85c1dc;">**FI:**</span>
  Varmista, että kaikki sanat on kirjoitettu oikein.

  <span style="color:#85c1dc;">**RU:**</span>
  Убедись, что все слова написаны без ошибок.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1990 = msg(
  mf`Veendu, et kõik sõnad oleksid kirjavigadeta.`,
  mf`Varmista, että kaikki sanat on kirjoitettu oikein.`,
  mf`Убедись, что все слова написаны без ошибок.`,
)

export { m1990 as 'w.module.no-results.search.suggestions.items.ensure-no-typos' }